export interface IGlobalStore {
    id: string;
    
}

// GlobalStore.ts
class GlobalStore {
    private static store: Map<string, GlobalStore> = new Map();
    public configData: IGlobalStore;
  
    // Constructor nhận id từ ngoài vào
    private constructor(id: string) {
      this.configData = { id }; // Khởi tạo giá trị cho configData
    }
  
    // Lấy instance duy nhất của GlobalStore dựa trên id
    public static getInstance(id: string): GlobalStore {
      if (!this.store.has(id)) {
        // Nếu chưa có instance cho id này, khởi tạo mới
        this.store.set(id, new GlobalStore(id));
      }
      return this.store.get(id)!; // Trả về instance đã có hoặc vừa tạo
    }
  
  
  }
  
  export default GlobalStore;